import React from 'react';
import {Card} from "primereact/card";
import Span from "../../system/components/span";
import CardviewTitleDescriptionIconValue from "./cardview-title-description-icon-value";
import {useTranslate} from "../../system/useTranslate";
import Table from "../../system/components/table";
import {useSelector} from "react-redux";
import {severity} from "../../system/utils";
import DashboardCards from "./dashboard-cards";

function DashboardTemplate1(props) {
    const translate = useTranslate();
    const {config} = useSelector((state) => state.app);

    return (
        <div className="w-full h-full flex flex-column">
            <DashboardCards quickReports={props.quickReports}/>
            {
                props.message && (
                    <div className="pr-3 pl-3">
                        <div className={`flex flex-column gap-2 border-1 w-full p-3 border-round-3xl ${severity("text", props.message.type)} ${severity("border", props.message.type)} ${severity("bg", props.message.type, 100)}`}>
                            <div className="flex align-items-baseline gap-1">
                                <span className={`font-bold pi ${props.message.icon} text-sm`}/>
                                <span className="font-bold">{translate(props.message.title)}</span>
                            </div>
                            <span className="text-gray-700">{translate(props.message.content)}</span>
                        </div>
                    </div>
                )
            }
            {
                props.prepareTable&&(
                    <div className="p-3">
                        <div className="p-2 border-round-3xl border-gray-300 surface-card border-1">
                            <Table loading={props.loading} cellClassName={`${config.language!=="fa"&&"english-font"}`} showHeader={false} fieldsConfig={props.prepareTable.fieldsConfig} fields={props.prepareTable.fields} value={props.data?props.data:[]}/>
                        </div>
                    </div>
                )
            }
            <div className="pb-3">
                {props.help && (
                    <div className="p-3">
                        <CardviewTitleDescriptionIconValue title={translate("help")}>
                            <ul className="w-full m-1 pr-4">
                                {props.help && props.help.map(h=>(<li>
                                    <div className="flex flex-column text-sm">
                                        <span className="font-bold">{translate(h.title)}</span>
                                        <span>{translate(h.description)}</span>
                                    </div>
                                </li>))}
                            </ul>

                        </CardviewTitleDescriptionIconValue>

                    </div>
                )}
            </div>

        </div>
    );
}

export default DashboardTemplate1;